import React from 'react';
import {StyledSeparator} from './style';

const Separator = ({items}) => {
  return (
      <StyledSeparator />
  );
}

export default Separator;